import { type AppState } from '../types';

export const getIsPostInPreview = (state: AppState) => state.isPostInPreview;
